<template>
  <div>


    <div class="row">
      <div class="col-5">
        <label>Condizione</label>
        <select class="form-control" v-model="newCondition" @change="loadTypeOfNewExternalCondition($event)">
          <option :value="externalCondition.id" v-for="externalCondition in  external_conditions">
            {{ externalCondition.name }}
          </option>
        </select>
      </div>
      <div class="col-5">
        <label>Valore</label>
        <div v-if="selectedExternalCondition.typology == 'number'">
          <input class="form-control" type="number" step="0.01" v-model="newValue">
        </div>
        <div v-else-if="selectedExternalCondition.typology == 'date'">
          <input class="form-control" type="date" v-model="newValue">
        </div>
        <div v-else-if="selectedExternalCondition.typology == 'text'">
          <select class="form-control" v-model="newValue">
            <option v-for="(optionLabel,keyId) in selectedExternalCondition.text_options" :value="keyId">
              {{ optionLabel }}
            </option>
          </select>
        </div>


      </div>
    </div>
    <br>
    <div class="form-buttons clear" style="text-align: right;">
      <button class="btn btn--green" @click="addCondition()" type="button">
        Aggiungi
      </button>
    </div>
    <hr>
    <div class="row">
      <div class="col-2">
      </div>
      <div class="col-4">
        <label>Condizione</label>
      </div>
      <div class="col-4">
        <label>Valore</label>
      </div>
      <div class="col-2">
      </div>
    </div>
    <div class="row" v-for="row in tableConditions">

      <div class="col-2">
        <button type="button" class="btn btn--danger btn-xs" @click="deleteCondition(row.id)"><i
            class="fas fa-trash"> </i></button>
      </div>
      <div class="col-4 mt-2">
        <label>
          {{ row.name }}
        </label>
      </div>
      <div class="col-4 mt-2">
        <label>{{ row.valueEnchanted }}</label>
      </div>
      <div class="col-2">
      </div>

    </div>

  </div>
</template>

<script>
export default {
  mounted() {
    this.getConditions();
  },
  props: {
    people_kpi: {
      type: Number,
      required: true
    },
    external_conditions: {
      type: [Array, Object],
      required: true
    },
  },
  data() {
    return {
      selectedExternalCondition: {
        typology: "number"
      },
      newCondition: null,
      newValue: null,
      tableConditions: []
    }
  },
  methods: {

    loadTypeOfNewExternalCondition(event) {

      this.selectedExternalCondition = this.external_conditions[event.target.value];
      console.log(this.selectedExternalCondition)

    },

    deleteCondition(id) {

      axios.delete(("/personExternalCondition/" + id), {}).then((response) => {
        this.getConditions();
      }).catch(function (error) {
        alert(error);
      });
    },
    getConditions() {
      axios.get(("/people-kpis/" + this.people_kpi + "/getExternalConditions"), {}).then((response) => {

        this.tableConditions = response.data;

      }).catch(function (error) {
        alert(error);
      });
    },

    addCondition() {
      if (this.newCondition === null) {
        alert("Seleziona una condizione");
        return;
      }
      let params = {
        value: this.newValue,
        kpi_external_condition_id: this.newCondition,
      };


      axios.post("/people-kpis/" + this.people_kpi + "/getExternalConditions", params).then((response) => {

        if (response.data.code == 0) {
          this.getConditions();
        } else {

          Vue.swal.fire({
            title: response.data.message,
            text: "",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok'
          });
        }


      }).catch(function (error) {
        console.log("error add " + error);
      });
    },
    updateCondition(row) {

      let params = {
        rowExternalCondition: {
          value: row.value,
          kpi_external_condition_id: row.external_condition_id
        }
      };

      axios.put("/personExternalCondition/" + row.id, params).then((response) => {

        this.getConditions();

      }).catch(function (error) {

        console.log("error add " + error);
      });
    }
  }
}
</script>

<style>

</style>
